import { success } from 'toastr';
import * as types from './actionTypes';

const initialState = {
  discrepancyList: [],
  devicePunchList: {},
  employeeShiftProcess: [],
  employeeShiftChange: [],
  employeeShiftCodes: [],
  employeeRemoveShift: [],
  employeeMobilePunchaAppList:[],
  template: null,
  importedData: [],
  success: false,
  loading: false,
  error: null,
};

const biometricReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_BIOMETRIC_DISCREPANCY_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.FETCH_BIOMETRIC_DISCREPANCY_SUCCESS:
      return { ...state, loading: false, discrepancyList: action.payload, success: false };
    case types.FETCH_BIOMETRIC_DISCREPANCY_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.FETCH_BIOMETRIC_DEVICE_PUNCH_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.FETCH_BIOMETRIC_DEVICE_PUNCH_SUCCESS:
      return { ...state, loading: false, devicePunchList: action.payload, success: false };
    case types.FETCH_BIOMETRIC_DEVICE_PUNCH_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.SAVE_BIOMETRIC_DEVICE_PUNCH_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.SAVE_BIOMETRIC_DEVICE_PUNCH_FAILURE:
      return { ...state, loading: false, success: false };

    case types.DISCREPANCY_SHIFT_UPDATE_REQUEST:
      return { ...state, loading: true, error: null,success: false };
    case types.DISCREPANCY_SHIFT_UPDATE_SUCCESS:
      return { ...state, loading: false, data: action.payload,success: false };
    case types.DISCREPANCY_SHIFT_UPDATE_FAILURE:
      return { ...state, loading: false, error: action.payload,success: false };

    case types.DISCREPANCY_PUNCH_UPDATE_REQUEST:
      return { ...state, loading: true, success: false, error: null ,success: false };
    case types.DISCREPANCY_PUNCH_UPDATE_SUCCESS:
      return { ...state, loading: false, success: true, data: action.payload,success: true  };
    case types.DISCREPANCY_PUNCH_UPDATE_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload ,success: false };

    case types.FETCH_SHIFT_PROCESS_REQUEST:
      return { ...state, success: false,loading:true };

    case types.FETCH_SHIFT_PROCESS_SUCCESS:
      return { ...state,employeeShiftProcess:action.payload, success: false,loading:false };

    case types.FETCH_SHIFT_PROCESS_FAILURE:
      return { ...state, success: false,loading:false };
    
    case types.SAVE_SHIFT_PROCESS_REQUEST:
      return { ...state, success: false,loading:true };

    case types.SAVE_SHIFT_PROCESS_SUCCESS:
      return { ...state, success: true,loading:false };

    case types.SAVE_SHIFT_PROCESS_FAILURE:
      return { ...state, success: false,loading:false };
    
    case types.FETCH_SHIFT_CHANGE_REQUEST:
      return { ...state, success: false,loading:true };

    case types.FETCH_SHIFT_CHANGE_SUCCESS:
      return { ...state, employeeShiftChange: action.payload, success: false,loading:false };

    case types.FETCH_SHIFT_CHANGE_FAILURE:
      return { ...state, success: false,loading:false };

    case types.FETCH_SHIFT_EMPLOYEE_SHIFTCODE_REQUEST:
      return { ...state, success: false ,loading:true};

    case types.FETCH_SHIFT_EMPLOYEE_SHIFTCODE_SUCCESS:
      return { ...state, employeeShiftCodes: action.payload, success: false ,loading:false};

    case types.FETCH_SHIFT_EMPLOYEE_SHIFTCODE_FAILURE:
      return { ...state, success: false,loading:false };

     case types.SAVE_SHIFT_CHANGE_REQUEST:
      return { ...state, success: false,loading:true };

    case types.SAVE_SHIFT_CHANGE_SUCCESS:
      return { ...state, success: true,loading:false };

    case types.SAVE_SHIFT_CHANGE_FAILURE:
      return { ...state, success: false ,loading:false};

     case types.FETCH_SHIFT_REMOVE_REQUEST:
      return { ...state, success: false,loading:true };

    case types.FETCH_SHIFT_REMOVE_SUCCESS:
      return { ...state,employeeRemoveShift: action.payload, success: false,loading:false };

    case types.FETCH_SHIFT_REMOVE_FAILURE:
      return { ...state, success: false,loading:false };

    case types.REMOVE_SHIFT_REQUEST:
      return { ...state, success: false,loading:true };

    case types.REMOVE_SHIFT_SUCCESS:
      return { ...state, success: true,loading:false };

    case types.REMOVE_SHIFT_FAILURE:
      return { ...state, success: false,loading:false };


       // 🔹 Common loading
    case types.PUNCHLIST_GET_TEMPLATE_REQUEST:
    case types.PUNCHLIST_IMPORT_REQUEST:
    case types.PUNCHLIST_SAVE_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    // 🔹 Get Template Success
    case types.PUNCHLIST_GET_TEMPLATE_SUCCESS:
      return { ...state, loading: false, success: false, template: action.payload };

    // 🔹 Import Success
    case types.PUNCHLIST_IMPORT_SUCCESS:
      return { ...state, loading: false, success: false, importedData: action.payload?.data || [] };

    // 🔹 Save Success
    case types.PUNCHLIST_SAVE_SUCCESS:
      return { ...state, loading: false, success: true };

    // 🔹 Failures
    case types.PUNCHLIST_GET_TEMPLATE_FAILURE:
    case types.PUNCHLIST_IMPORT_FAILURE:
    case types.PUNCHLIST_SAVE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.FETCH_EMPLOYEE_MOBILE_PUNCH_REQUEST:
      return { ...state, success: false, loading: true };
    case types.FETCH_EMPLOYEE_MOBILE_PUNCH_SUCCESS:
      return { ...state, employeeMobilePunch: action.payload, success: false, loading: false };
    case types.FETCH_EMPLOYEE_MOBILE_PUNCH_FAILURE:
      return { ...state, success: false };

    case types.FETCH_EMPLOYEE_MOBILE_BREAKLISTS_REQUESTS:
      return { ...state, success: false };
    case types.FETCH_EMPLOYEE_MOBILE_BREAKLISTS_SUCCESS:
      return { ...state, employeeBreakings: action.payload, success: false, loading: false };
    case types.FETCH_EMPLOYEE_MOBILE_BREAKLISTS_FAILURE:
      return { ...state, loading: false, success: false };

    case types.SAVE_GENERATED_MOBILE_APPROVAL_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.SAVE_GENERATED_MOBILE_APPROVAL_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.SAVE_GENERATED_MOBILE_APPROVAL_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.FETCH_EMPLOYEE_MOBILE_PUNCH_APPROVAL_REQUEST:
      return { ...state, success: false, loading: true };
    case types.FETCH_EMPLOYEE_MOBILE_PUNCH_APPROVAL_SUCCESS:
      return { ...state, employeeMobilePunchaAppList: action.payload, success: false, loading: false };
    case types.FETCH_EMPLOYEE_MOBILE_PUNCH_APPROVAL_FAILURE:
      return { ...state, loading: false, success: false };

    case "RESET_PUNCH_EMPLOYEE_APPROVAL_LIST":
      return {
        ...state,
        employeeMobilePunch: [],
        employeeMobilePunchaAppList: [],
        success: false
      };

    case "RESET_SHIFT_CHANGE_LIST":
    return {
      ...state,
      employeeShiftChange: [],
      success: false
    };

    case types.DELETE_MOBILE_PUNCH:
      return { ...state, success: false,loading:true };

    case types.DELETE_MOBILE_PUNCH_SUCCESS:
      return { ...state, success: false,loading:false };

    case types.DELETE_MOBILE_PUNCH_FAILURE:
      return { ...state, success: false,loading:false };

    case types.RESET_SHIFT_PROCESS:
      return { ...state, employeeShiftProcess: [], success: false, loading: false };
      
    default:
      return state;
  }
};

export default biometricReducer;
